import React from 'react';
import { Toaster } from 'sonner';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Testimonials } from './components/Testimonials';
import { SpecialOffer } from './components/SpecialOffer';
import { ContactForm } from './components/ContactForm';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  return <div className="min-h-screen bg-gray-50 font-sans selection:bg-pool-500 selection:text-white" data-id="element-0">
      <Toaster position="top-center" richColors data-id="element-1" />
      <Header data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <About data-id="element-5" />
        <Services data-id="element-6" />
        <Process data-id="element-7" />
        <WhyChooseUs data-id="element-8" />
        <Testimonials data-id="element-9" />
        <SpecialOffer data-id="element-10" />
        <ContactForm data-id="element-11" />
        <FAQ data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
      <FloatingWhatsApp data-id="element-14" />
    </div>;
}